import { render, staticRenderFns } from "./ScreenList.vue?vue&type=template&id=7c5d0c5d&"
import script from "./ScreenList.vue?vue&type=script&lang=js&"
export * from "./ScreenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports